import type { PaymentVars } from '@/types';

export function startEpayPaymentWindow(paymentVars: PaymentVars) {
    // If psp is epay, we need to set up for starting ePay payment later
    // Only if in information view (payment not yet begun)
    const ePayScript = document.createElement('script');
    ePayScript.src = 'https://ssl.ditonlinebetalingssystem.dk/integration/ewindow/paymentwindow.js';
    ePayScript.type = 'text/javascript';
    ePayScript.charset = 'UTF-8';
    document.head.appendChild(ePayScript);
    const localPaymentVarKeys: any[] = [];
    const localPaymentVars: any[] = [];

    for (const key in paymentVars) {
        localPaymentVarKeys.push(key);
    }
    localPaymentVarKeys.sort();
    for(let i = 0; i < localPaymentVarKeys.length; i++) {
        localPaymentVars[localPaymentVarKeys[i]] = (paymentVars as any)[localPaymentVarKeys[i]];
    }


    ePayScript.onload = () => {
        if (paymentVars) {
            openEpayWindow(localPaymentVars, 0);
        }
    };
    console.log("Initiating ePay payment with vars:", localPaymentVars);
    console.log("ePay script appended to document.");
}

function openEpayWindow(paymentVars: any[], tries: number){
    if ((window as any).PaymentWindow) {
    const pw = new (window as any).PaymentWindow(paymentVars);
    pw.open();
    } 
    else {
        if (tries < 10) {
            setTimeout(() => {
            openEpayWindow(paymentVars, tries + 1);
            }, 1500);
        } 
        else {
            console.error('Failed to load ePay PaymentWindow script.');
        }
    }
}